import { useState, useEffect } from 'react';
import pubSub from './pubSub';

const usePubSub = name => {
  const [state, setState] = useState(pubSub.query(name));

  useEffect(() => {
    const pS = pubSub.subscribe(name, setState);

    return () => pS();
  }, []);

  return [
    state,
    $ => {
      pubSub.publish(name, $);
    },
  ];
};

export default usePubSub;
